import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=09c18d7d&scoped=true&"
import script from "./CartIcon.vue?vue&type=script&lang=ts&"
export * from "./CartIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CartIcon.vue?vue&type=style&index=0&id=09c18d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c18d7d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCounter: require('/var/www/packages/theme/components/atoms/Counter.vue').default})
